export default __webpack_public_path__ + "static/media/7.36c21546.jpg";